var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManufacturer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24.0039,
    height: 24,
    rx: 4,
    fill: "#FF9839"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.765 7.075C18.689 7.03112 18.6028 7.00801 18.515 7.00801C18.4272 7.00801 18.341 7.03112 18.265 7.075L14 9.19V7.5C13.9997 7.41477 13.9777 7.33102 13.936 7.2567C13.8942 7.18238 13.8342 7.11997 13.7616 7.07538C13.6889 7.0308 13.6061 7.00552 13.5209 7.00195C13.4358 6.99838 13.3511 7.01665 13.275 7.055L9 9.19V5.5C9 5.36739 8.94732 5.24021 8.85355 5.14645C8.75979 5.05268 8.63261 5 8.5 5H5.5C5.36739 5 5.24021 5.05268 5.14645 5.14645C5.05268 5.24021 5 5.36739 5 5.5V18H19V7.5C19.0002 7.41503 18.9787 7.33141 18.9376 7.25705C18.8964 7.18269 18.8371 7.12004 18.765 7.075ZM15 17H13V13.5H15V17ZM18 17H16V13C16 12.8674 15.9473 12.7402 15.8536 12.6464C15.7598 12.5527 15.6326 12.5 15.5 12.5H12.5C12.3674 12.5 12.2402 12.5527 12.1464 12.6464C12.0527 12.7402 12 12.8674 12 13V17H6V6H8V10.81L13 8.31V10.81L18 8.31V17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManufacturer);
export default __webpack_public_path__ + "static/media/manufacturer.6ef1da12a9509e9b72788a22383cb00c.svg";
export { ForwardRef as ReactComponent };